module.exports = __webpack_public_path__ + "static/media/crossfit.e8acfbb4.svg";